<template>
	<div>
		<TnHeading
			type="h1"
			size="l"
			responsive
			class="title"
			>{{ title }}</TnHeading
		>
		<RichText
			:text="description"
			class="product-description"
		></RichText>
	</div>
</template>

<script>
import ECommerceProductMixin from "../../ECommerceProductMixin/ECommerceProductMixin.js";
import { marked } from "marked";
export default defineNuxtComponent({
	name: "ProductDescription",
	mixins: [ECommerceProductMixin],

	props: {
		staticTitle: {
			type: String,
		},
		staticDescription: {
			type: String,
		},
	},

	data() {
		return {
			product: null,
		};
	},

	computed: {
		title() {
			if (this.staticTitle) return this.staticTitle;
			else if (this.eCommerceProduct?.title) {
				let title = this.eCommerceProduct?.title;
				if (title) {
					title = title.split(/\d+?\s?GB/)[0];
					title = title.split(/\d+?\s?TB/)[0];
					title = title.split(",")[0];
				}
				return title;
			}

			return "";
		},
		description() {
			if (this.staticDescription) return this.staticDescription;

			const filteredDescription = this.eCommerceProduct.description
				?.replace(/<strong>/g, "")
				?.replace(/<\/strong>/g, "");
			if (this.eCommerceProduct.description) return marked.parse(filteredDescription);

			return "";
		},
	},
});
</script>

<style lang="scss" scoped>
.title {
	color: $color-neutrals-900-shade;
	margin-bottom: $spacing-l;
}

.product-description {
	:deep() {
		color: $color-neutrals-900-shade;

		strong {
			margin-bottom: -$spacing-s;
			font-size: 18px;

			@media screen and (width <= 767px) {
				font-size: 14px;
			}
		}

		h2 {
			margin-bottom: $spacing-s;

			@include font-title-s;
			@include breakpoint(mobile) {
				@include font-title-m;
			}
		}

		p {
			color: $color-neutrals-900-shade;
			margin-bottom: $spacing-l;

			@include font-text-m;
			@include breakpoint(mobile) {
				@include font-text-l;
			}
		}

		ul {
			display: flex;
			flex-direction: column;

			li {
				display: flex;
				color: $color-neutrals-900-shade;
				flex-direction: column;
				margin-bottom: $spacing-l;

				@include font-text-m;
				&::before {
					transform: translateY(1px);
					@include breakpoint(mobile) {
						transform: translateY(-3px);
					}
				}
			}
		}
	}
}
</style>
